<template>
  <div>
    <van-nav-bar
      title="微信支付"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <div class="pay-box">
      <!-- <div v-if="!isWeixin && codeUrl && goods.name">
        <div class="qrcode-box">
          <img :src="qrcodeUrl" />
          <div class="qrcode-price">支付金额：<small>¥</small>{{ goods.amount }}</div>
          <div class="qrcode-title">{{ goods.name }}
            （<span class="qrcode-detail"><small>¥</small>{{ goods.price }} × {{ goods.count }}</span>）
          </div>
        </div>
      </div> -->
      <div v-if="isWeixin" class="wx-notify">等待微信支付...</div>
      <div v-if="error" class="error">支付参数不正确！</div>
    </div>
  </div>
</template>

<script>
import siteMixin from '@/utils/site-mixin';
// import QRCode from 'qrcode';
export default {
  mixins: [siteMixin],
  componentName: 'GoodsPay',
  components: {
  },
  props: {
    goods: {
      type: Object,
      default: () => {
        return {};
      }
    },
    orderid: String,
    codeUrl: String, // 扫码付url
    wxpayparams: Object // 微信浏览器付款参数
  },
  data() {
    return {
      loading: false,
      error: false,
      qrcodeUrl: null,
      isok: false
    }
  },
  computed: {

  },
  beforeRouteLeave(to, from, next) {
    if (this.isok) {
      next();
      return;
    }
    this.Dialog.confirm({
      message: '亲，已完成支付了吗？'
    }).then(() => {
      next();
    }).catch(() => {
      next(false);
    });
  },
  created() {
    this.$on('order.paid', () => {
      this.isok = true;
    });
  },
  mounted () {
  },
  activated() {
    this.doWxPay();
  },
  methods: {
    goBack() {
      this.$router.push('/stu-main/'+ this.orderid);
    },
    // 微信支付
    doWxPay() {
      this.error = false;
      // if (!this.isWeixin) {
      //   if (!this.codeUrl) {
      //     this.error = true;
      //     return;
      //   }
      //   QRCode.toDataURL(this.codeUrl, {margin:1, width:130, height:130, color:{light:'#FFFFFFCC'}})
      //     .then(url => {
      //       this.qrcodeUrl = url;
      //     })
      //     .catch(err => {
      //     });
      //   return;
      // }
      if (!this.wxpayparams) {
        this.error = true;
        return;
      }
    
      this.isok = false;
      const self = this;
      const onBridgeReady = () => {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', this.wxpayparams,
          (res) => {
            self.isok = true;
            if (res.err_msg == "get_brand_wcpay_request:ok" ) {
              self.$router.push('/stu-main/'+ self.orderid);
              self.Toast('支付成功！');
            }
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。 
            else {
              console.log(JSON.stringify(res))
            }
          }
        ); 
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener ) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pay-box {
  margin-top:50px;
  .wx-notify {
    padding-top:2rem;
    text-align:center;
    color:green;
  }
  .error {
    padding-top:2rem;
    text-align:center;
    color:red;
  }
}
.qrcode-box {
  .flex-center();
  flex-direction:column;
  width:100%;
  img {
    height:200px;
  }
  .qrcode-price {
    margin-top:.5rem;
    .fontsize(1.1rem);
    color:@orangecolor;
  }
  .qrcode-title {
    margin-top:.5rem;
    padding:1rem;
  }
}

</style>